<template>
  <div id="contenedor-programacion-toolbar">
    <v-toolbar
    flat
    dense>
    <div
      style="width: 150px" class="mr-2">
      <ejercicio-picker
        v-model="filtros.ejercicio"
        sinPeriodo
        class="mr-2">
      </ejercicio-picker>
    </div>
    <div
      style="width: 350px"
      class="mr-2">
      <custom-text-field
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <filtros
    :listaOficiosAutorizacion="listaOficiosAutorizacion"
    :filtros="filtros"></filtros>
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="nuevo">
    </custom-button>
    <excel-oficios-autorizacion
    class="ml-2"
    :listaOficiosAutorizacion="getOficiosAutorizacion"
    :ejercicio="ejercicio"
    >
    </excel-oficios-autorizacion>
  </v-toolbar>
  </div>
</template>

<script>

import CustomButton from '@/components/buttons/Button.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import ExcelOficiosAutorizacion from '@/components/exportar/exceles/ExcelOficiosAutorizacion.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'ProgramacionToolBar',
  props: {
    ejercicio: {
      type: String,
      required: false,
      default: '',
    },
    listaOficiosAutorizacion: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    Filtros,
    CustomButton,
    EjercicioPicker,
    CustomTextField,
    ExcelOficiosAutorizacion,

  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    nuevo() {
      this.$emit('nuevoOficio');
    },
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscar = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscar = '';
    },
  },
  computed: {
    getOficiosAutorizacion() {
      if (!this.listaOficiosAutorizacion) return [];
      return this.listaOficiosAutorizacion;
    },
  },

};
</script>

<style lang="scss">

</style>
